export default {"src":"https://s.nxtpen.com/larkplayer-campaigns/_next/static/media/dot.33262159.svg","height":10,"width":10};